import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Flex,
  Text,
} from '@chakra-ui/react';
import { ListingComparableSetFragment } from '@client/graphql/__generated__/types';
import { NormalizedPropertyDetails } from '~/apps/consumer/components/Listings/ListingPage/utils';
import { ComparableState } from '~/apps/consumer/pages/ListingSetup/Comparables/ComparablesPage';
import { CompsSummary } from '../../../ViewComps/CompsSummary';
import { DraggableEditCompsMapSidebarListingCards } from './ListingCard/DraggableEditCompsMapListingCards';

export const EditCompsMapSidebar = ({
  onAdd,
  containerRef,
  listing,
  comparableSet,
  comps,
  setComps,
}: {
  onAdd: () => void;
  containerRef: React.RefObject<HTMLDivElement>;
  listing?: NormalizedPropertyDetails;
  comparableSet?: ListingComparableSetFragment;
  comps: ComparableState[];
  setComps: React.Dispatch<React.SetStateAction<ComparableState[]>>;
}) => {
  return (
    <Card
      background={{ base: 'bg.main', md: 'black' }}
      height={{ base: 'auto', md: 'calc(100% - 40px)' }}
      position={{ base: 'unset', md: 'absolute' }}
      right={{ base: '0', md: '10px' }}
      top={{ base: '0', md: '10px' }}
      width={{ base: '100%', md: '280px' }}
      zIndex={2}
    >
      <CardHeader>
        <Flex alignItems="center" justifyContent="space-between">
          <Text color="whiteAlpha.600">Your Comps</Text>
          <Button size="xs" onClick={onAdd}>
            Add
          </Button>
        </Flex>
      </CardHeader>
      <CardBody minHeight="0" px={0}>
        <Flex direction="column" gap={2} height="100%">
          <Flex px={4}>
            <CompsSummary
              shortLabel
              comparableSet={comparableSet}
              listing={listing}
            />
          </Flex>
          <DraggableEditCompsMapSidebarListingCards
            comps={comps}
            containerRef={containerRef}
            setComps={setComps}
          />
        </Flex>
      </CardBody>
    </Card>
  );
};
